import {
  BlockStack,
  Button,
  reactExtension,
} from "@shopify/ui-extensions-react/customer-account";
import { PhotoUploadBanner } from "./components/PhotoUploadBanner";
import { UploadModal } from "./components/UploadModal";
import { useOrderStatus } from "./hooks/useOrderStatus";

export default reactExtension(
  "customer-account.order-status.block.render",
  () => <Extension />,
);

function Extension() {
  const {
    orderId,
    loading,
    hasSeatProducts,
    handleCloseModal,
    uploadButtonText,
  } = useOrderStatus();

  if (loading || !hasSeatProducts) {
    return null;
  }

  const uploadButton = (
    <Button
      kind="primary"
      overlay={<UploadModal onClose={handleCloseModal} orderId={orderId} />}
    >
      {uploadButtonText}
    </Button>
  );

  return (
    <BlockStack spacing="base">
      <PhotoUploadBanner uploadButton={uploadButton} />
    </BlockStack>
  );
}
